import { QuickStartStep } from '../enums/quickStartStep'
import type { QuickStartStepConfig } from '../types/quickStartStepConfig'

interface GetQuickStartStepsParams {
  completedSteps: QuickStartStep[]
  isCreateAccountStepApplicable: boolean
  isEInvoicingApplicable: boolean
}

const stepOrder: QuickStartStep[] = [
  QuickStartStep.CreateAccount,
  QuickStartStep.Account,
  QuickStartStep.Invoice,
  QuickStartStep.Purchases,
  QuickStartStep.EInvoicing,
  QuickStartStep.Bank,
]

export const getQuickStartSteps = ({
  completedSteps,
  isCreateAccountStepApplicable,
  isEInvoicingApplicable,
}: GetQuickStartStepsParams): QuickStartStepConfig[] =>
  stepOrder
    .filter((step) => step !== QuickStartStep.EInvoicing || isEInvoicingApplicable)
    .filter((step) => step !== QuickStartStep.CreateAccount || isCreateAccountStepApplicable)
    .map((step) => ({
      // Step 1 is always complete. Everything else is driven by the persisted list.
      isCompleted: step === QuickStartStep.CreateAccount || completedSteps.includes(step),
      step,
    }))
